import React from 'react';

import AboutToExpireBody from './AboutToExpireBody';
import { AboutToExpireModalWrapper } from './AboutToExpire.styles';
import AccessTime from '@mui/icons-material/AccessTime';
import Button from '../../../../components/Button';
import { DateTime } from 'luxon';
import StylovyzeComposableDialog from '../../../../components/StylovyzeComposableDialog';
import { useGlobalization } from '../../../../contexts/GlobalizationProvider';

export interface AboutToExpireModalProps {
	readonly open: boolean;
	readonly expiryDate: DateTime;
	readonly onExtend: () => void;
	readonly onLogout: () => void;
}

export default function AboutToExpireModal({
	open,
	expiryDate,
	onExtend,
	onLogout,
}: AboutToExpireModalProps): JSX.Element {
	const { t } = useGlobalization();

	return (
		<StylovyzeComposableDialog
			open={open}
			onCancel={() => void 0}
			header={<AccessTime color="secondary" sx={{ fontSize: 40 }} />}
			width="342px"
			footer={
				<>
					<Button color="secondary" onClick={onLogout}>
						{t('Close Session')}
					</Button>
					<Button
						color="secondary"
						variant="contained"
						onClick={onExtend}>
						{t('Extend Session')}
					</Button>
				</>
			}>
			<AboutToExpireModalWrapper>
				<AboutToExpireBody expiryDate={expiryDate} />
			</AboutToExpireModalWrapper>
		</StylovyzeComposableDialog>
	);
}
